var map = {
	"./dashboard.svg": 85751,
	"./deals.svg": 10390,
	"./disputes.svg": 21874,
	"./logout.svg": 24175,
	"./requisites.svg": 92983,
	"./settings.svg": 34794,
	"./statistic.svg": 25721,
	"./traderOperators.svg": 74516
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42025;